module.exports = __webpack_public_path__ + "static/media/sg1cr44.bf1b3234.png";